const createResponse = (success = false, errors = {}) => ({ success, errors });

export const baseResponse = apiResponse => {
  if (apiResponse.status === 422) {
    return createResponse(false, apiResponse.data.errors);
  }

  if (apiResponse.status > 300 || apiResponse.status < 199) {
    return createResponse(false);
  }

  return createResponse(true);
}